<template>
  <div class="m-pc-banner">
    <img
      alt=""
      :src="banner.src.value"
      v-if="banner && banner.display.value"
      @click="openUrl()"
      :style="{ cursor: bannerHref == '' ? '' : 'pointer' }"
    />
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Banner",
  data() {
    return {
      banner: {
        display: {
          value: false
        },
        src: {
          vaule: ""
        }
      },
      bannerHref: ""
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.banner = res.banner;
      this.bannerHref = res.banner_href.text.value;
    });
  },
  methods: {
    openUrl() {
      if (
        this.bannerHref &&
        (this.bannerHref.indexOf("http://") == 0 ||
          this.bannerHref.indexOf("https://") == 0)
      ) {
        window.open(this.bannerHref);
      }
    }
  },
  components: {}
};
</script>
